import React from "react";
import { Button } from "react-bootstrap";
import "../information&promo.css";
const Promo2 = () => {
  return (
    <div>
      <div
        className="promo-explanation nunito fade-in2"
        style={{ color: "white" }}
      >
        <div className="promo-text">
          <h2 className="roleway">
            Berikan Kendaraan Anda Perlindungan Bulanan yang Luar Biasa!
          </h2>
          <p>
            We Car Care kini hadir dengan Paket Bulanan yang eksklusif untuk
            Anda. Dengan harga yang terjangkau, Anda bisa memberikan perawatan
            istimewa untuk kendaraan Anda setiap minggu. Pilih paket yang sesuai
            dengan kebutuhan Anda:
          </p>
          <ul>
            <li>
              <span className="highlight">Paket A (Rp300.000/Bulan)</span>
              <br />
              Nikmati 4x Premium Wash seharga yang sangat terjangkau. Setiap
              minggu, kendaraan Anda akan mendapatkan perawatan eksterior dan
              interior yang bersih dan segar.
            </li>
            <li>
              <span className="highlight">Paket B (Rp400.000/Bulan)</span>
              <br />
              Rasakan kelebihan Ultimate Wash 1x dan 3x Premium Wash. Setiap
              minggu, kendaraan Anda akan mendapatkan perawatan lengkap yang
              akan membuatnya bersinar dan terasa baru.
            </li>
          </ul>
          <p>
            Dengan Paket Bulanan dari We Car Care, kendaraan Anda akan selalu
            siap untuk perjalanan, dan Anda akan menikmati kenyamanan tanpa
            khawatir. Jadwalkan perawatan rutin Anda dan jadikan setiap minggu
            sebagai momen perawatan kendaraan yang menyenangkan.
          </p>
          <p>
            Jangan lewatkan kesempatan ini untuk merawat kendaraan Anda secara
            teratur. Hubungi kami dan berlangganan Paket Bulanan sekarang!
          </p>
          <p>Protect Your Vehicle Investment With The Best Car Services</p>
        </div>
        <Button
          variant="none"
          target="_blank"
          rel="noreferrer"
          className="price-card-button"
          href={
            "https://api.whatsapp.com/send?phone=+6281399333280&text=Hallo%20saya%20tertarik%20untuk%20melakukan%20booking%20untuk%20Paket%3A%20.....%20Bulanan%20Terima%20kasih%20%21"
          }
        >
          Book Now
        </Button>
      </div>
    </div>
  );
};

export default Promo2;
